import {
  Checkbox,
  FormControl,
  InputAdornment,
  InputLabel,
  ListItemText,
  ListSubheader,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import SearchIcon from "@mui/icons-material/Search";
import { useState } from "react";
import { useMemo } from "react";
import { useEffect } from "react";


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
      overflowX: "auto",
      "& .MuiSelected": {
        color: "#F9FAFB !important",
      },
    },
  },
  MenuListProps: {
    disablePadding: true,
  },
  background: "#F2F4F7 !important",
};

const useStyles = makeStyles((theme) => ({
  label: {
    fontFamily: "Inter-Regular !important",
    fontSize: "1.6rem !important",
    lineHeight: "2.4rem !important",
    color: "#98A2B3 !important",
    background: "#F2F4F7 !important",
    fontWeight: "400 !important",
    padding: "0px !important",
    "&.Mui-focused": {
      display: "none !important",
      color: " #84CAFF !important",
    },
  },
  select: {
    minWidth: "15rem",
    fontFamily: "Inter-Regular !important",
    fontSize: "1.6rem !important",
    border: "1px solid #EFF8FF !important",
    lineHeight: "2.4rem !important",
    background: "#F2F4F7 !important",
    color: "#98A2B3 !important",
    textAlign: "left",
    overflow: "hidden !important",
    whiteSpace: "nowrap !important",
    textOverflow: "ellipsis !important",
    fontWeight: "400 !important",
    //  border: "1px solid #D0D5DD !important",
    borderRadius: "0.8rem !important",
    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
    "&.Mui-focused": {
      border: "1px solid #84CAFF !important",
      boxShadow:
        "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF  !important",
      background: "#FFFFFF !important",
    },
    "& .MuiSelect-outlined": {},
    "& fieldSet": {
      border: "none",
    },
    "& .MuiSelect-icon": {
      width: "2em !important",
      height: "2em !important",
      top: "0.5rem !important",
    },
    "&.Mui-error": {
      border: "1px solid red !important",
    },
    "& .MuiSelect-select": {
      // padding: "0.8rem 1.4rem !important",
      padding: "1.4rem 1.4rem !important",
    },
  },
  DropDownName: {
    margin: "0",
    " & span": {
      fontFamily: "Inter-Medium",
      fontSize: "1.35rem",
      lineHeight: "2.4rem",
      letterSpacing: "0.3px",
      color: "#344054",
      marginTop: "0.7rem",
      // width:"80% !important",
      marginBottom: "0.3rem !important",
      // display: 'inline-block !important',
      textAlign: "left !important",
      overflow: "hidden !important",
      whiteSpace: "nowrap !important",
      textOverflow: "ellipsis !important",
      textTransform: "uppercase !important",
    },
    "&.Mui-focused": {
      border: "1px solid #84CAFF !important",
      boxShadow:
        "0px 1px 2px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #D1E9FF  !important",
      background: "#FFFFFF !important",
    },
  },
}));


const containsText = (text, searchText) =>
  text?.toLowerCase()?.indexOf(searchText?.toLowerCase()) > -1;

const MultiSelectDropDown = ({
  value = "",
  handleChange,
  list,
  placeHolder,
  ReportDropDown,
  setAllSelected=()=>{},
}) => {

  const classList = useStyles();
  const [searchText, setSearchText] = useState("");
  const isAllSelected = ReportDropDown?(list.length >= 0 || value?.length === list?.length) :(list?.length > 0 && value?.length === list?.length);
    const [displayOptions, setDisplayOptions] = useState([]);


// console.log("value in drop======>", value)
  useEffect(() => {
    setDisplayOptions(list);
    setAllSelected(list)
  }, [list]);

  useEffect(() => {
    setDisplayOptions(
      list.filter((option) => containsText(option?.name, searchText))
    );
    setAllSelected(list.filter((option) => containsText(option?.name, searchText)))
  }, [searchText]);

  // const displayedOptions = useMemo(
  //   () => list.filter((option) => containsText(option?.name, searchText)),
  //   [searchText]
  // );


  return (
    <FormControl
      sx={{ width: ReportDropDown ? "30rem":"40rem" }}
      // error={!HelperText.cpData}
    >
      {value === "" ? (
        <InputLabel
          id="demo-simple-select-label"
          className={classList?.label}
          sx={[
            {
              color: "#667085 !important",
              background: "#F2F4F7 !important",
            },
          ]}
        >
          {placeHolder}
        </InputLabel>
      ) : (
        ""
      )}
      <Select
      onClose={() => {
        setSearchText((prev) => prev)
      }}
      onOpen={() => {
        setSearchText((prev) => prev)
      }}
        labelId="demo-multiple-checkbox-label"
        id="demo-multiple-checkbox"
        multiple
        className={classList.select}
        value={value}
        sx={[
          {
            color: "#D0D5DD",
            background: " #F2F4F7  !important",
            "& .MuiList-root-MuiMenu-list": {
              maxWidth: "25% !important",
              "& .MuiButtonBase-root-MuiMenuItem-root.Mui-selected": {
                backgroundColor: "rgba(25, 118, 210, 0.08) !important",
              },
            },
            "& img": {
              display: "none",
            },
            "& .makeStyles-wrapperli-11 > div:nth-of-type(1)": {
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: "80%",
            },
          },
        ]}
        onChange={(e) => {
          handleChange(e);
        }}
        input={<OutlinedInput />}
        rend
        renderValue={(selected) => selected?.map((m) => m?.name).join(", ")}
        MenuProps={MenuProps}
      >
        <ListSubheader sx={{ marginTop: "10px" }}>
          <TextField
            size="small"
            // Autofocus on textfield
            autoFocus
            sx={{
              "& .MuiInputBase-root-MuiOutlinedInput-root": {
                fontSize: "2rem",
              },
            }}
            placeholder={placeHolder || "Search by name"}
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon sx={{ transform: "scale(1.5)" }} />
                </InputAdornment>
              ),
            }}
            value={searchText}
            inputProps={{ style: { fontSize: "2rem" } }}
            onChange={(e) => setSearchText(e.target.value)}
            onKeyDown={(e) => {
              if (e.key !== "Escape") {
                // Prevents autoselecting item while typing (default Select behaviour)
                e.stopPropagation();
              }
            }}
          />
        </ListSubheader>
        {displayOptions?.length > 0 && (
          <MenuItem
            value="all"
            sx={[
              {
                fontFamily: "Inter-Medium",
                fontSize: ReportDropDown ?"1.3rem":"1.4rem !important",
                background: "#FFFfF !important",
                color: "#101828 !important",
                borderBottom: "1px solid #F2F4F7 !important",
                "& ul .MuiList-root-MuiMenu-list": {
                  paddingBottom: "0rem !important",
                },
              },
            ]}
          >
            <Checkbox
              sx={{ transform: "scale(1.5)" }}
              checked={isAllSelected}
              indeterminate={value.length > 0 && value.length < list.length}
            />


            <ListItemText
              className={classList.DropDownName}
              primary="Select All"
            />
          </MenuItem>
        )}
        {displayOptions?.map((el, index) => (
          <MenuItem
            key={`${el}_${index}`}
            value={el}
            sx={[
              {
                fontFamily: "Inter-Medium",
                fontSize: ReportDropDown ?"1.3rem !important":"1.4rem !important",
                background: "#FFFfF !important",
                color: "#101828 !important",
                borderBottom: "1px solid #F2F4F7 !important",
                "& ul .MuiList-root-MuiMenu-list": {
                  paddingBottom: "0rem !important",
                },
              },
            ]}
          >
            <Checkbox
              sx={{ transform: "scale(1.5)" }}
              checked={value.some(item => (item.id === el.id))}
            />
         

            <ListItemText
            className={ classList.DropDownName}
        
              primary={el?.name}
            />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MultiSelectDropDown;
